module.exports = __webpack_public_path__ + "img/rotten_broccoli.a88ed4fb.png";